<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding10" :style="{ height: `${this.screenHeight - 30}px`, overflow: 'auto' }">
        <el-row>
            <el-col :span="16" class="align-left">
                <h3>手术安全核查</h3>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">科别：{{ surgeryInfo.dic_section }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">姓名：{{ surgeryInfo.patient_name }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">性别：{{ surgeryInfo.sex || `--` }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">年龄：{{ surgeryInfo.age || `--` }}</label>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12" class="align-left">
                <label style="line-height: 35px">{{ T(`anesthesia_index.visit_no`) }}：{{ surgeryInfo.visit_no || `--` }}</label>
            </el-col>
            <el-col :span="12" class="align-left">
                <label style="line-height: 35px">手术日期：{{ $moment(surgeryInfo.plan_time).format('YYYY/MM/DD HH:mm:ss') || `--` }}</label>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="align-left">
                <label style="line-height: 35px">拟施手术：{{ surgeryInfo.surgeries || `--` }}</label>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <!-- <el-col :lg="4" :md="4" >
         <div class="block" style="text-align:left">
          <el-timeline>
            <el-timeline-item placement="bottom" v-for="item in sys_enums.SaftyCheckStage" :key="item.value" :type="unCheckedList.indexOf(item.value)!==-1?'info':'primary'">
              <div style="cursor:pointer;" @click="scanCheck()">{{item.label}}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        </el-col>       -->
            <el-col :lg="8" :md="8">
                <div class="padding10" style="height: 500px">
                    <el-card :body-style="{ padding: '5px', height: '650px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">麻前检查</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-checkbox v-if="isShowSelectAll" v-model="isSelectedAll.p1" @change="selectedAll(1)">全选</el-checkbox>
                            </el-col>
                        </el-row>
                        <div class="card-content">
                            <cus-form ref="form-p1" :columns="sys_check_list" :data="data_p.data_p1" @extrabutton-click="ExtraButtonClick" @confirm="saveP1"></cus-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :lg="8" :md="8" v-show="showBeforeOper">
                <div class="padding10">
                    <el-card :body-style="{ padding: '5px', height: '650px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">术前检查</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-checkbox v-if="isShowSelectAll" v-model="isSelectedAll.p2" @change="selectedAll(2)">全选</el-checkbox>
                            </el-col>
                        </el-row>
                        <div class="card-content">
                            <cus-form ref="form-p1" :columns="sys_check_list2" :data="data_p.data_p2" @extrabutton-click="ExtraButtonClick" @confirm="saveP1"></cus-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :lg="8" :md="8" v-if="showOutRoom">
                <div class="padding10">
                    <el-card :body-style="{ padding: '5px', height: '650px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">出室检查</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-checkbox v-if="isShowSelectAll" v-model="isSelectedAll.p3" @change="selectedAll(3)">全选</el-checkbox>
                            </el-col>
                        </el-row>
                        <div class="card-content">
                            <cus-form ref="form-p1" :columns="sys_check_list3" :data="data_p.data_p3" @extrabutton-click="ExtraButtonClick" @confirm="saveP1"></cus-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SaftyCheck2`,
    props: {},
    data() {
        return {
            title: `安全核查`,
            showBeforeOper: false,
            showOutRoom: false,
            isSelectedAll: {
                p1: undefined,
                p2: undefined,
                p3: undefined
            },
            token: this.$route.query.token,
            processlist: [],
            name: {
                doctor: undefined,
                anesthesiaDoctor: undefined,
                nurse: undefined
            },
            currentList: [],
            data_p: {
                data_p1: { safecheck_p1_mqjc: `` },
                data_p2: {
                    safecheck_p2_rsja: ``,
                    safecheck_p2_shfx: ``,
                    safecheck_p2_mzys: ``,
                    safecheck_p2_shhs: ``
                },
                data_p3: { safecheck_p3_csjc: `` }
            },
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: {},
            checked: false,
            unCheckedList: [],
            isShowSelectAll: false,
            allPermissions: []
        }
    },
    created() {
        // 此页面不再使用，已经合并到/components/Surgery/SaftyCheck/Index.vue
        sessionStorage.setItem(`token`, this.token)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.init()
        this.isShowHidden()
    },
    mounted() {
        // this.init()
    },
    computed: {
        ...mapGetters([`sysuser/workers_by_duty`, `currentUser`, `permissions`, `screenHeight`, `sys_enums`, `active_ward`]),
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        sys_check_list() {
            let editCheckTime = this.allPermissions && this.allPermissions.findIndex(item => item.permission === `security_check:edit_checkTime`) > -1
            let list = [
                {
                    type: `p`,
                    prop: `safty_check_start_time`,
                    label: { content: `开始时间`, position: `left` },
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `p`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    readonly: true,
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `datetime`,
                    prop: `safty_check_start_time`,
                    label: { content: `开始时间`, position: `left` },
                    colspan: 12,
                    area: [2]
                },
                {
                    type: `datetime`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 12,
                    area: [2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p1_mqjc`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `患者身份确认` },
                        { value: `2`, label: `手术部位与标示确认` },
                        { value: `3`, label: `手术方式确认` },
                        { value: `4`, label: `手麻、麻醉知情同意` },
                        { value: `5`, label: `麻醉方式确认` },
                        { value: `6`, label: `麻醉设备安全检查完成` },
                        { value: `7`, label: `血氧监测建立` },
                        { value: `8`, label: `静脉通道建立完成` },
                        // ,{value:'9',label:"计划自体输血"}
                        { value: `10`, label: `假体` },
                        { value: `11`, label: `体内植入物` },
                        { value: `12`, label: `影像学资料` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p1_zitixue`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `计划自体输血` },
                        { value: `2`, label: `计划异体输血` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_gms`,
                    label: { content: `患者过敏史`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 12,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_qidao`,
                    label: { content: `气道障碍或呼吸功能障碍`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` },
                        { value: 3, label: `设备提供支持` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_wanzhengxing`,
                    label: { content: `皮肤完整性检查`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,

                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `safecheck_p1_qt`,
                    label: { content: `其他`, position: `top` },
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p1_doctor_name`,
                    label: { content: `手术医生签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`医生`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p1_anesthesia_name`,
                    label: { content: `麻醉医生签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`医生`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p1_nurse_name`,
                    label: { content: `巡回护士签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`护士`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: { content: ` `, position: `top` },
                    options: (that, { row }) => {
                        if (row.origion.p1_checked) {
                            return [
                                {
                                    label: `保存`,
                                    type: `primary`,
                                    emit: `checkedThrough`,
                                    permission: `default`,
                                    align: `left`
                                }
                            ]
                        }
                        return [
                            {
                                label: `核对通过`,
                                type: `primary`,
                                emit: `checkedThrough`,
                                permission: `default`
                            },
                            {
                                label: `核对不通过`,
                                type: `default`,
                                emit: `checkedReject`,
                                permission: `default`
                            }
                        ]
                    },
                    colspan: 8,
                    config: {
                        align: `left`
                    },
                    area: [1, 2]
                }
            ]

            return _.filter(list, d => {
                return editCheckTime ? d.area.indexOf(2) > -1 : d.area.indexOf(1) > -1
            })
        },
        sys_check_list2() {
            let editCheckTime = this.allPermissions && this.allPermissions.findIndex(item => item.permission === `security_check:edit_checkTime`) > -1
            let list = [
                {
                    type: `p`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `datetime`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 12,
                    area: [2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_rsja`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `4`, label: `患者身份确认` },
                        { value: `1`, label: `手术部位确认` },
                        { value: `2`, label: `手术方式确认` },
                        { value: `3`, label: `手术体位确认` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_shfx`,
                    label: { content: `手术医生陈述：`, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `预计手术时间` },
                        { value: `2`, label: `预计失血量` },
                        { value: `3`, label: `强调关注点` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_mzys`,
                    label: { content: `麻醉医生陈述：`, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `强调关注点` },
                        { value: `2`, label: `应对方案` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_shhs`,
                    label: { content: `手术护士陈述：`, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `物品灭菌合格` },
                        { value: `2`, label: `应对方案` },
                        { value: `3`, label: `仪器设备完好` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p2_gms`,
                    label: { content: `术前0.5-2小时内给与预防性抗生素`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 12,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p2_wanzhengxing`,
                    label: { content: `需要相关影像资料`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,
                    area: [1, 2]
                },
                // ,{
                //   type: "radio",
                //   prop: "safecheck_p2_qidao",
                //   label: {content:'气道障碍或呼吸功能障碍',position:'top'},
                //   readonly:false,
                //   options:[{value:1,label:"有"}
                //   ,{value:2,label:"无"}
                //   ,{value:3,label:'设备提供支持'}],
                //   colspan:24,
                // }
                {
                    type: `string`,
                    prop: `safecheck_p2_qt`,
                    label: { content: `其他`, position: `top` },
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p2_doctor_name`,
                    label: { content: `手术医生签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`医生`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p2_anesthesia_name`,
                    label: { content: `麻醉医生签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`医生`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p2_nurse_name`,
                    label: { content: `巡回护士签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`护士`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: { content: ` `, position: `top` },
                    options: (that, { row }) => {
                        if (row.origion.p2_checked) {
                            return [
                                {
                                    label: `保存`,
                                    type: `primary`,
                                    emit: `checkedThrough`,
                                    permission: `default`
                                }
                            ]
                        }
                        return [
                            {
                                label: `核对通过`,
                                type: `primary`,
                                emit: `checkedThrough`,
                                permission: `default`
                            },
                            {
                                label: `核对不通过`,
                                type: `default`,
                                emit: `checkedReject`,
                                permission: `default`
                            }
                        ]
                    },
                    colspan: 8,
                    config: {
                        align: `left`
                    },
                    area: [1, 2]
                }
            ]
            return _.filter(list, d => {
                return editCheckTime ? d.area.indexOf(2) > -1 : d.area.indexOf(1) > -1
            })
        },
        sys_check_list3() {
            let editCheckTime = this.allPermissions && this.allPermissions.findIndex(item => item.permission === `security_check:edit_checkTime`) > -1
            let list = [
                {
                    type: `p`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `datetime`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 12,
                    area: [2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p3_csjc`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `记录实施手术名称 ` },
                        // ,{value:'2',label:"手术方式确认"}
                        // ,{value:'3',label:"手术体位确认"}
                        { value: `4`, label: `引流管` },
                        { value: `5`, label: `胃管` },
                        { value: `6`, label: `中心静脉路` },
                        { value: `7`, label: `尿管` },
                        { value: `8`, label: `气管插管` },
                        { value: `9`, label: `动脉通路` },
                        { value: `10`, label: `x-ray和签名` }
                    ],
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_qdshwp`,
                    label: { content: `清点手术用物`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `数量正确` },
                        { value: 2, label: `数量不正确` }
                    ],
                    colspan: 8,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_ssbbqr`,
                    label: { content: `手术标本确认`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 8,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_wanzhengxing`,
                    label: { content: `皮肤完整性检查`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 8,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_sbjx`,
                    label: { content: `仪器设备需要检修`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 8,
                    area: [1, 2]
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_brqx`,
                    label: { content: `病人去向`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `PACU` },
                        { value: 2, label: `回病房` },
                        { value: 3, label: `ICU` }
                    ],
                    colspan: 16,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `safecheck_p3_qt`,
                    label: { content: `其他`, position: `top` },
                    colspan: 24,
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p3_doctor_name`,
                    label: { content: `手术医生签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`医生`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p3_anesthesia_name`,
                    label: { content: `麻醉医生签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`医生`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `safecheck_p3_nurse_name`,
                    label: { content: `巡回护士签名`, position: `top` },
                    colspan: 8,
                    options: this.worker[`护士`] || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: { content: ` `, position: `top` },
                    options: (that, { row }) => {
                        if (row.origion.p3_checked) {
                            return [
                                {
                                    label: `保存`,
                                    type: `primary`,
                                    emit: `checkedThrough`,
                                    permission: `default`
                                }
                            ]
                        }
                        return [
                            {
                                label: `核对通过`,
                                type: `primary`,
                                emit: `checkedThrough`,
                                permission: `default`
                            },
                            {
                                label: `核对不通过`,
                                type: `default`,
                                emit: `checkedReject`,
                                permission: `default`
                            }
                        ]
                    },
                    colspan: 8,
                    config: {
                        align: `left`
                    },
                    area: [1, 2]
                }
            ]
            return _.filter(list, d => {
                return editCheckTime ? d.area.indexOf(2) > -1 : d.area.indexOf(1) > -1
            })
        }
    },
    methods: {
        async init() {
            if (!this.surgeryId) return
            let that = this
            // 获取当前手术信息
            let req = this.myaxios.get(`/api/Operation/Home/Get?id=${this.surgeryId}`)
            let req1 = this.myaxios.get(`/api/Intraoperative/SaftyCheck/Records?surgeryInfoId=${this.surgeryId}`)
            let req2 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/OccuredEvents?surgeryInfoId=${this.surgeryId}&recordType=1`)
            this.myaxios.all(req, req1, req2).then(async([data, data1, data2]) => {
                let checkArr = this.sys_enums.SaftyCheckStage
                if (!checkArr || checkArr.length == 0) {
                    checkArr = await this.saftyCheckStage()
                }
                var arr1 = _.filter(data2, { event_name: `麻醉开始` })
                var arr2 = _.filter(data2, { event_name: `手术开始` })
                this.showBeforeOper = arr1.length > 0
                this.showOutRoom = arr2.length > 0

                this.surgeryInfo = data
                let passData = _.filter(data1, { is_pass: true })
                _.reduce(
                    data1,
                    function(items, item, key) {
                        // 获取数据
                        let startTime = item && item.start_time || _.filter(data2, { event_name: `进手术间` })[0] && _.filter(data2, { event_name: `进手术间` })[0].occur_time
                        // let occurTime = _.filter(data2, { config_remark: item.enum_safty_check.toString() })[0] && _.filter(data2, { config_remark: item.enum_safty_check.toString() })[0].occur_time
                        let occurTime = item && item.check_date
                        let r = _.reduce(
                            item.safty_check_items,
                            function(result, value, key) {
                                result[value.check_name] = value.check_value
                                result[`p${item.enum_safty_check}_checked`] = item.is_pass
                                result[`enum_safty_check`] = item.enum_safty_check
                                result[`id`] = item.id
                                result[`safty_check_start_time`] = (startTime && that.$moment(startTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                                result[`safty_check_occur_time`] = (occurTime && that.$moment(occurTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                                return result
                            },
                            {}
                        )
                        that.data_p[`data_p${item.enum_safty_check}`] = Object.assign({}, that.data_p[`data_p${item.enum_safty_check}`], r)
                    },
                    {}
                )

                // 获取当前核查阶段
                let stage = _.map(passData, d => {
                    return d.enum_safty_check
                })
                let r = _.filter(checkArr, d => {
                    return stage.indexOf(d.value) === -1
                })
                if (r.length !== 0) {
                    this.currentList = {
                        id: r[0].value,
                        label: r[0].label
                    }
                } else {
                    this.currentList = {
                        id: checkArr[stage.length - 1].value,
                        label: checkArr[stage.length - 1].value.label
                    }
                }
                // 未核查记录
                this.unCheckedList = _.map(r, d => {
                    return d.value
                })

                // ACIS-23527 已记录保存手术医生、巡回护士、麻醉医生情况下，各节点安全核查自动提取带出
                if (!that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_doctor_name`] && data.plan_surgeon_doctor && data.plan_surgeon_doctor.value) {
                    that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_doctor_name`] = data.plan_surgeon_doctor.value
                }
                if (!that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_anesthesia_name`] && data.plan_anes_doctor && data.plan_anes_doctor.value) {
                    that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_anesthesia_name`] = data.plan_anes_doctor.value
                }
                if (!that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_nurse_name`] && data.plan_circuit_nurse && data.plan_circuit_nurse.length > 0) {
                    that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_nurse_name`] = data.plan_circuit_nurse[0].value
                }

                if (!that.data_p[`data_p1`][`safty_check_start_time`]) {
                    that.$set(that.data_p[`data_p1`], `safty_check`, true)
                    let ptime = _.filter(data2, { event_name: `进手术间` })[0] && _.filter(data2, { event_name: `进手术间` })[0].occur_time || new Date()
                    that.$set(that.data_p[`data_p1`], `safty_check_start_time`, that.$moment(ptime).format(`YYYY-MM-DD HH:mm`))
                }

                // if (!that.data_p[`data_p1`][`safty_check_occur_time`]) {
                //     that.data_p[`data_p1`][`safty_check_occur_time`] = that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                // }

                // if (!that.data_p[`data_p2`][`safty_check_occur_time`]) {
                //     that.$set(that.data_p[`data_p2`], `safty_check`, true)
                //     that.data_p[`data_p2`][`safty_check_occur_time`] = that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                // }
                // if (!that.data_p[`data_p3`][`safty_check_occur_time`]) {
                //     that.$set(that.data_p[`data_p3`], `safty_check`, true)
                //     that.data_p[`data_p3`][`safty_check_occur_time`] = that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                // }
            })
        },
        async saftyCheckStage() {
            let data = await this.myaxios.get(`/api/AcisSystem/SystemServer/GetEnums`)
            let r = _.groupBy(data, `code`)
            _.each(r, d => {
                _.each(d, i => {
                    i.code = i.description
                })
            })
            return r.SaftyCheckStage
        },
        ExtraButtonClick(target) {
            this[target.emit](target)
        },
        isShowHidden() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(permissions => {
                this.allPermissions = permissions
                this.isShowSelectAll = _.find(permissions, { no: `security_check:selectAll` }) != undefined
            }).catch(e => {
                console.log(e)
            })
        },
        selectedAll(key) {
            let that = this
            if (this.isSelectedAll[`p${key}`]) {
                that.data_p[`data_p${key}`][`safecheck_p${key}_mqjc`] = `1,2,3,4,5,6,7,8,9,10,11,12`
                that.data_p[`data_p${key}`][`safecheck_p${key}_rsja`] = `1,2,3,4`
                that.data_p[`data_p${key}`][`safecheck_p${key}_shfx`] = `1,2,3`
                that.data_p[`data_p${key}`][`safecheck_p${key}_shhs`] = `1,2,3`
                that.data_p[`data_p${key}`][`safecheck_p${key}_mzys`] = `1,2`
                that.data_p[`data_p${key}`][`safecheck_p${key}_csjc`] = `1,2,3,4,5,6,7,8,9,10`
            } else {
                that.data_p[`data_p${key}`][`safecheck_p${key}_mqjc`] = ``
                that.data_p[`data_p${key}`][`safecheck_p${key}_rsja`] = ``
                that.data_p[`data_p${key}`][`safecheck_p${key}_shfx`] = ``
                that.data_p[`data_p${key}`][`safecheck_p${key}_shhs`] = ``
                that.data_p[`data_p${key}`][`safecheck_p${key}_csjc`] = ``
                that.data_p[`data_p${key}`][`safecheck_p${key}_mzys`] = ``
            }
        },
        checkedThrough(row) {
            let that = this
            let { formdata } = row
            let lists = _.reduce(
                formdata,
                function(result, value, key) {
                    let type = typeof value
                    if (value !== undefined && key !== `origion`) {
                        result.push({
                            id: 0,
                            biz_safty_check_id: that.currentList.id,
                            check_name: key,
                            check_value: type === `object` ? value.toString() : value
                        })
                    }
                    return result
                },
                []
            )
            let surgenDoctor = _.filter(this.worker[`医生`], d => {
                return d.value == formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_doctor_name`]
            })
            let anesthesiaDoctor = _.filter(this.worker[`医生`], d => {
                return d.value == formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_anesthesia_name`]
            })
            let anesthesiaNurse = _.filter(this.worker[`护士`], d => {
                return d.value == formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_nurse_name`]
            })
            let data = {
                id: formdata.origion.id || 0,
                biz_surgery_info_id: this.surgeryId,
                enum_safty_check: formdata.origion.enum_safty_check || that.currentList.id,
                surgeon: formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_doctor_name`] || undefined,
                anesthesiologist: formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_anesthesia_name`] || undefined,
                circuit_nurse: formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_nurse_name`] || undefined,
                surgeon_name: surgenDoctor && surgenDoctor[0] && surgenDoctor[0].label,
                anesthesiologist_name: anesthesiaDoctor && anesthesiaDoctor[0] && anesthesiaDoctor[0].label,
                circuit_nurse_name: anesthesiaNurse && anesthesiaNurse[0] && anesthesiaNurse[0].label,
                is_pass: true,
                check_date: formdata.safty_check_occur_time,
                start_time: formdata.safty_check_start_time,
                safty_check_items: lists
            }
            // 条件判断
            if (data.surgeon === undefined || data.surgeon_name === undefined) {
                this.$message.warning(`手术医生确认不能为空`)
                return
            }
            if (data.anesthesiologist === undefined || data.anesthesiologist_name === undefined) {
                this.$message.warning(`麻醉医生确认不能为空`)
                return
            }
            if (data.circuit_nurse === undefined || data.circuit_nurse_name === undefined) {
                this.$message.warning(`麻醉护士确认不能为空`)
                return
            }

            let sussmessage = ``
            switch (formdata.origion.enum_safty_check || that.currentList.id) {
            case 1:
                sussmessage = `麻前检查保存成功`
                break
            case 2:
                sussmessage = `术前检查保存成功`
                break
            case 3:
                sussmessage = `出室检查保存成功`
                break
            default:
                sussmessage = `麻前检查保存成功`
                break
            }
            let req = that.myaxios.post(`/api/Intraoperative/SaftyCheck/Records`, data)
            req.then(data => {
                this.$message.success(sussmessage)
                this.init()
            }).catch(e => {
                console.log(e)
            })
        },
        checkedReject(row) {
            let that = this
            let { formdata } = row
            let lists = _.reduce(
                formdata,
                function(result, value, key) {
                    let type = typeof value
                    if (value !== undefined && key !== `origion`) {
                        result.push({
                            id: 0,
                            biz_safty_check_id: that.currentList.id,
                            check_name: key,
                            check_value: type === `object` ? value.toString() : value
                        })
                    }
                    return result
                },
                []
            )
            let surgenDoctor = _.filter(this.worker[`医生`], d => {
                return d.value == formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_doctor_name`]
            })
            let anesthesiaDoctor = _.filter(this.worker[`医生`], d => {
                return d.value == formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_anesthesia_name`]
            })
            let anesthesiaNurse = _.filter(this.worker[`护士`], d => {
                return d.value == formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_nurse_name`]
            })
            let data = {
                id: formdata.origion.id || 0,
                biz_surgery_info_id: this.surgeryId,
                enum_safty_check: formdata.origion.enum_safty_check || that.currentList.id,
                surgeon: formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_doctor_name`] || undefined,
                anesthesiologist: formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_anesthesia_name`] || undefined,
                circuit_nurse: formdata[`safecheck_p${formdata.origion.enum_safty_check || that.currentList.id}_nurse_name`] || undefined,
                surgeon_name: surgenDoctor && surgenDoctor[0] && surgenDoctor[0].label,
                anesthesiologist_name: anesthesiaDoctor && anesthesiaDoctor[0] && anesthesiaDoctor[0].label,
                circuit_nurse_name: anesthesiaNurse && anesthesiaNurse[0] && anesthesiaNurse[0].label,
                is_pass: false,
                safty_check_items: lists
            }

            // 条件判断
            if (data.surgeon === undefined || data.surgeon_name === undefined) {
                this.$message.warning(`手术医生确认不能为空`)
                return
            }
            if (data.anesthesiologist === undefined || data.anesthesiologist_name === undefined) {
                this.$message.warning(`麻醉医生确认不能为空`)
                return
            }
            if (data.circuit_nurse === undefined || data.circuit_nurse_name === undefined) {
                this.$message.warning(`麻醉护士确认不能为空`)
                return
            }

            let errmessage = ``
            switch (formdata.origion.enum_safty_check || that.currentList.id) {
            case 1:
                errmessage = `麻前检查核对不通过`
                break
            case 2:
                errmessage = `术前检查核对不通过`
                break
            case 3:
                errmessage = `出室检查核对不通过`
                break
            default:
                errmessage = `麻前检查核对不通过`
                break
            }
            let req = that.myaxios.post(`/api/Intraoperative/SaftyCheck/Records`, data)
            req.then(data => {
                this.$message.success(errmessage)
                this.init()
            }).catch(e => {
                console.log(e)
            })
        },
        scanCheck() {},
        saveP1(row) {
            console.log(row)
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.init()
        }
    }
}
</script>
<style scoped>
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
h3 {
    margin: 0;
}
</style>
<style  lang="less">
.handover-nurse .el-timeline-item__node {
    cursor: pointer;
    z-index: 2;
    &:hover {
        width: 20px;
        height: 20px;
        left: -6px;
        top: -6px;
        background: #409eff;
    }
}
// .safecheck_p1_gms  {
//   label.el-form-item__label{
//     color:red !important;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/SaftyCheck2.vue